import { Drawer, styled, drawerClasses } from '@mui/material';

export const DrawerStyled = styled(Drawer)(({ theme }) => ({
  [`& .${drawerClasses.paper}`]: {
    padding: theme.spacing(4),
    maxWidth: '40%',
  },
})) as typeof Drawer;
